import React from "react";
import { costRows } from "../../data/megapack";
import { E } from "../Emoji";
export function CostSection() {
  return <section aria-labelledby="costo" className="bg-night" data-id="element-114" data-mp="2tusau3u5n9fd">
      <div className="mx-auto max-w-2xl px-5 pb-14" data-id="element-115" data-mp="2f7gxpxibrhd5">
        <h2 id="costo" className="text-center text-3xl font-black text-white" data-id="element-116" data-mp="2f6nydhlp3u51">
          <E data-id="element-117" data-mp="2k4zay03dkiqy">⚖️ ¿CUÁNTO CUESTA NO TENERLO?</E>
        </h2>
        <div className="mt-7 overflow-hidden rounded-2xl border border-line/50" data-id="element-118" data-mp="266iwfmz9tny9">
          <div className="grid grid-cols-2 bg-navy-2 px-4 py-3 text-sm font-black" data-id="element-119" data-mp="268vlek3g4ykt">
            <span className="text-mute" data-id="element-120" data-mp="2a9fdvad2re0m"><E data-id="element-121" data-mp="1w8bgn7gpxbxu">❌ Sin Megapack</E></span>
            <span className="text-bright" data-id="element-122" data-mp="1w9d285vd1gtt"><E data-id="element-123" data-mp="1wa5zmg8fitza">✅ Con Megapack</E></span>
          </div>
          <ul className="divide-y divide-line/30 bg-navy" data-id="element-124" data-mp="216mpbeva1geh">
            {costRows.map(r => <li key={r.without} className="grid grid-cols-2 gap-3 px-4 py-3 text-sm" data-id="element-125" data-mp="3qm2wiopn4s1q">
                <span className="text-white/70" data-id="element-126" data-mp="3vlz1aq65wnic">{r.without}</span>
                <span className="font-black text-white" data-id="element-127" data-mp="3vjcrskzpnxxh">{r.withGuide}</span>
              </li>)}
          </ul>
        </div>
        <p className="mt-10 text-center text-3xl font-black italic leading-tight text-white" data-id="element-128" data-mp="3awxaufph59kq">
          La próxima falla puede ser distinta.
          <span className="block text-bright" data-id="element-129" data-mp="3onaisi2d8oa2">Empezá con un método claro.</span>
        </p>
      </div>
    </section>;
}